import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    getCommerciauxList, getEquipes, createEquipe, updateEquipe, deleteEquipe, getPortefeuilles,
    setEquipeMembres, getStatsEquipes, changeCommercialEquipe, getZones, uploadUserPhoto
} from '../services/api';
import {
    FiUsers, FiSearch, FiPlus, FiEdit2, FiTrash2, FiEye, FiFilter,
    FiUserPlus, FiActivity, FiDollarSign, FiMapPin, FiChevronLeft, FiChevronRight,
    FiUserCheck, FiClock, FiTarget, FiX, FiCheck, FiRefreshCw, FiCamera
} from 'react-icons/fi';

const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_URL = isDev ? 'http://localhost:5056' : '';

const Commerciaux: React.FC = () => {
    const navigate = useNavigate();
    const [commerciaux, setCommerciaux] = useState<any[]>([]);
    const [equipes, setEquipes] = useState<any[]>([]);
    const [statsEquipes, setStatsEquipes] = useState<any[]>([]);
    const [zones, setZones] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const [globalStats, setGlobalStats] = useState<any>({});
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [filterEquipe, setFilterEquipe] = useState('');
    const [filterZone, setFilterZone] = useState('');
    const [tab, setTab] = useState<'liste' | 'equipes'>('liste');

    // Modal equipe
    const [showModal, setShowModal] = useState(false);
    const [editEquipe, setEditEquipe] = useState<any>(null);
    const [eqForm, setEqForm] = useState({ nom: '', description: '', couleur: '#3B82F6', responsable_id: '' });

    // Modal assign
    const [showAssign, setShowAssign] = useState(false);
    const [assignEquipeId, setAssignEquipeId] = useState<number | null>(null);
    const [assignMembers, setAssignMembers] = useState<number[]>([]);
    const [allCommerciaux, setAllCommerciaux] = useState<any[]>([]);
    const [portefeuilles, setPortefeuilles] = useState<Record<number, any>>({});

    const n = (v: any) => Math.round(Number(v) || 0);
    const fmt = (v: any) => n(v).toLocaleString('fr-FR');

    const loadData = async () => {
        setLoading(true);
        try {
            const cRes = await getCommerciauxList({ page, search, equipe_id: filterEquipe || undefined, zone_id: filterZone || undefined });
            setCommerciaux(cRes.data.data || []);
            setTotal(cRes.data.total || 0);
            setGlobalStats(cRes.data.stats || {});
        } catch (e) { console.error('Commerciaux list error:', e); }
        try {
            const pRes = await getPortefeuilles();
            const map: Record<number, any> = {};
            (pRes.data.data || []).forEach((p: any) => { map[p.id] = p; });
            setPortefeuilles(map);
        } catch (e) { console.error('Portefeuilles error:', e); }
        try {
            const eRes = await getEquipes();
            setEquipes(eRes.data || []);
        } catch (e) { console.error('Equipes error:', e); }
        try {
            const sRes = await getStatsEquipes();
            setStatsEquipes(sRes.data || []);
        } catch (e) { console.error('Stats equipes error:', e); }
        try {
            const zRes = await getZones();
            setZones(zRes.data || []);
        } catch (e) { console.error('Zones error:', e); }
        setLoading(false);
    };

    useEffect(() => { loadData(); }, [page, search, filterEquipe, filterZone]);

    const handleCreateEquipe = () => {
        setEditEquipe(null);
        setEqForm({ nom: '', description: '', couleur: '#3B82F6', responsable_id: '' });
        setShowModal(true);
    };

    const handleEditEquipe = (eq: any) => {
        setEditEquipe(eq);
        setEqForm({ nom: eq.nom, description: eq.description || '', couleur: eq.couleur, responsable_id: eq.responsable_id || '' });
        setShowModal(true);
    };

    const handleSaveEquipe = async () => {
        try {
            if (editEquipe) {
                await updateEquipe(editEquipe.id, eqForm);
            } else {
                await createEquipe(eqForm);
            }
            setShowModal(false);
            loadData();
        } catch { alert('Erreur'); }
    };

    const handleDeleteEquipe = async (id: number) => {
        if (!window.confirm('Supprimer cette equipe ?')) return;
        try { await deleteEquipe(id); loadData(); } catch { alert('Erreur'); }
    };

    const handleOpenAssign = async (eqId: number) => {
        setAssignEquipeId(eqId);
        try {
            const res = await getCommerciauxList({ limit: 500 });
            setAllCommerciaux(res.data.data);
            const currentMembers = res.data.data.filter((c: any) => c.equipe_id === eqId).map((c: any) => c.id);
            setAssignMembers(currentMembers);
        } catch (e) { console.error(e); }
        setShowAssign(true);
    };

    const toggleMember = (id: number) => {
        setAssignMembers(prev => prev.includes(id) ? prev.filter(m => m !== id) : [...prev, id]);
    };

    const handleSaveMembers = async () => {
        if (!assignEquipeId) return;
        try {
            await setEquipeMembres(assignEquipeId, { user_ids: assignMembers });
            setShowAssign(false);
            loadData();
        } catch { alert('Erreur'); }
    };

    const handleChangeEquipe = async (userId: number, equipeId: string) => {
        try {
            await changeCommercialEquipe(userId, { equipe_id: equipeId ? parseInt(equipeId) : null });
            loadData();
        } catch { alert('Erreur'); }
    };

    const totalPages = Math.ceil(total / 20);

    return (
        <div className="page-commerciaux">
            <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                <div>
                    <h1 style={{ display: 'flex', alignItems: 'center', gap: 10, margin: 0 }}>
                        <FiUsers style={{ color: '#16A34A' }} /> Commerciaux
                    </h1>
                    <p style={{ color: '#6b7280', margin: '4px 0 0' }}>Gestion et suivi de la force de vente</p>
                </div>
                <button className="btn btn-primary" onClick={handleCreateEquipe} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <FiPlus /> Nouvelle equipe
                </button>
            </div>

            {/* Stats KPI */}
            <div className="kpi-grid" style={{ marginBottom: 24 }}>
                <div className="kpi-card" style={{ borderLeftColor: '#16A34A' }}>
                    <div className="kpi-content">
                        <span className="kpi-value">{globalStats.total || 0}</span>
                        <span className="kpi-label">Commerciaux actifs</span>
                    </div>
                </div>
                <div className="kpi-card" style={{ borderLeftColor: '#3B82F6' }}>
                    <div className="kpi-content">
                        <span className="kpi-value">{globalStats.actifs_7j || 0}</span>
                        <span className="kpi-label">Actifs (7 derniers jours)</span>
                    </div>
                </div>
                <div className="kpi-card" style={{ borderLeftColor: '#F59E0B' }}>
                    <div className="kpi-content">
                        <span className="kpi-value">{equipes.length}</span>
                        <span className="kpi-label">Equipes</span>
                    </div>
                </div>
                <div className="kpi-card" style={{ borderLeftColor: '#8B5CF6' }}>
                    <div className="kpi-content">
                        <span className="kpi-value">{zones.length}</span>
                        <span className="kpi-label">Zones couvertes</span>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: '#f3f4f6', padding: 4, borderRadius: 10, width: 'fit-content' }}>
                {[{ key: 'liste', label: 'Liste des Commerciaux', icon: <FiUsers /> }, { key: 'equipes', label: 'Equipes', icon: <FiTarget /> }].map(t => (
                    <button key={t.key} className={`tab ${tab === t.key ? 'active' : ''}`}
                        onClick={() => setTab(t.key as any)}
                        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 18px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 500, fontSize: 14, background: tab === t.key ? '#fff' : 'transparent', color: tab === t.key ? '#16A34A' : '#6b7280', boxShadow: tab === t.key ? '0 1px 3px rgba(0,0,0,.1)' : 'none' }}>
                        {t.icon} {t.label}
                    </button>
                ))}
            </div>

            {/* === TAB LISTE === */}
            {tab === 'liste' && (
                <>
                    {/* Filters */}
                    <div className="card" style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginBottom: 20, padding: '12px 16px' }}>
                        <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
                            <FiSearch style={{ position: 'absolute', left: 10, top: 10, color: '#9ca3af' }} />
                            <input type="text" placeholder="Rechercher un commercial..." value={search}
                                onChange={e => { setSearch(e.target.value); setPage(1); }}
                                style={{ width: '100%', padding: '8px 8px 8px 34px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14 }} />
                        </div>
                        <select value={filterEquipe} onChange={e => { setFilterEquipe(e.target.value); setPage(1); }}
                            style={{ padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14 }}>
                            <option value="">Toutes les equipes</option>
                            {equipes.map(e => <option key={e.id} value={e.id}>{e.nom}</option>)}
                        </select>
                        <select value={filterZone} onChange={e => { setFilterZone(e.target.value); setPage(1); }}
                            style={{ padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14 }}>
                            <option value="">Toutes les zones</option>
                            {zones.map(z => <option key={z.id} value={z.id}>{z.nom}</option>)}
                        </select>
                        <button onClick={loadData} className="btn btn-outline" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <FiRefreshCw size={14} /> Actualiser
                        </button>
                    </div>

                    {/* Table */}
                    {loading ? <div className="loading">Chargement...</div> : (
                        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                            <table className="data-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: '#f9fafb' }}>
                                        <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 13, fontWeight: 600 }}>Commercial</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 13, fontWeight: 600 }}>Equipe</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 13, fontWeight: 600 }}>Zone</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: 13, fontWeight: 600 }}>Activites</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'right', fontSize: 13, fontWeight: 600 }}>CA du mois</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: 13, fontWeight: 600 }}>Clients</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'right', fontSize: 13, fontWeight: 600 }}>Encours</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: 13, fontWeight: 600 }}>Derniere connexion</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: 13, fontWeight: 600 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {commerciaux.map(c => (
                                        <tr key={c.id} style={{ borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}
                                            onClick={() => navigate(`/admin/commerciaux/${c.id}`)}>
                                            <td style={{ padding: '12px 16px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                    <div style={{ position: 'relative', width: 40, height: 40, flexShrink: 0 }}>
                                                        {c.photo_url ? (
                                                            <img src={`${API_URL}${c.photo_url}`} alt="" style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', border: '2px solid #E2E8F0' }} />
                                                        ) : (
                                                            <div style={{ width: 40, height: 40, borderRadius: '50%', background: c.equipe_couleur ? `${c.equipe_couleur}20` : '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', color: c.equipe_couleur || '#16A34A', fontWeight: 600, fontSize: 14 }}>
                                                                {c.prenom?.[0]}{c.nom?.[0]}
                                                            </div>
                                                        )}
                                                        <label style={{ position: 'absolute', bottom: -2, right: -2, width: 18, height: 18, borderRadius: '50%', background: '#fff', border: '1.5px solid #E2E8F0', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}
                                                            onClick={e => e.stopPropagation()}>
                                                            <FiCamera size={9} color="#64748B" />
                                                            <input type="file" accept="image/*" style={{ display: 'none' }}
                                                                onChange={async e => { if (e.target.files?.[0]) { try { await uploadUserPhoto(c.id, e.target.files[0]); loadData(); } catch {} } }} />
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: 600 }}>{c.prenom} {c.nom}</div>
                                                        <div style={{ fontSize: 12, color: '#9ca3af' }}>{c.matricule} &middot; {c.email}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ padding: '12px 16px' }} onClick={e => e.stopPropagation()}>
                                                <select value={c.equipe_id || ''} onChange={e => handleChangeEquipe(c.id, e.target.value)}
                                                    style={{ padding: '4px 8px', border: '1px solid #e5e7eb', borderRadius: 6, fontSize: 13, background: c.equipe_couleur ? `${c.equipe_couleur}15` : '#f9fafb', color: c.equipe_couleur || '#374151' }}>
                                                    <option value="">Sans equipe</option>
                                                    {equipes.map(e => <option key={e.id} value={e.id}>{e.nom}</option>)}
                                                </select>
                                            </td>
                                            <td style={{ padding: '12px 16px', fontSize: 13, color: '#6b7280' }}>{c.zone_nom || '-'}</td>
                                            <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                                <span style={{ background: n(c.nb_activites_mois) > 0 ? '#dcfce7' : '#f3f4f6', color: n(c.nb_activites_mois) > 0 ? '#16A34A' : '#9ca3af', padding: '4px 10px', borderRadius: 20, fontWeight: 600, fontSize: 13 }}>
                                                    {n(c.nb_activites_mois)}
                                                </span>
                                            </td>
                                            <td style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 600, color: n(c.ca_mois) > 0 ? '#16A34A' : '#9ca3af' }}>
                                                {fmt(c.ca_mois)} F
                                            </td>
                                            <td style={{ padding: '12px 16px', textAlign: 'center', fontSize: 13 }}>
                                                <div>{portefeuilles[c.id]?.nb_clients ?? n(c.nb_clients_mois)}</div>
                                                {portefeuilles[c.id]?.nb_clients_risque > 0 && (
                                                    <div style={{ fontSize: 10, color: '#EF4444', fontWeight: 700, marginTop: 2 }}>
                                                        {portefeuilles[c.id].nb_clients_risque} à risque
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{ padding: '12px 16px', textAlign: 'right', fontSize: 13 }}>
                                                <div style={{ fontWeight: 600, color: '#1E293B' }}>
                                                    {fmt(portefeuilles[c.id]?.total_encours || 0)} F
                                                </div>
                                                {portefeuilles[c.id]?.total_creance > 0 && (
                                                    <div style={{ fontSize: 10, color: '#EF4444', marginTop: 2 }}>
                                                        Créance: {fmt(portefeuilles[c.id].total_creance)} F
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{ padding: '12px 16px', textAlign: 'center', fontSize: 12, color: '#9ca3af' }}>
                                                {c.derniere_connexion ? new Date(c.derniere_connexion).toLocaleDateString('fr-FR') : 'Jamais'}
                                            </td>
                                            <td style={{ padding: '12px 16px', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
                                                <button onClick={() => navigate(`/admin/commerciaux/${c.id}`)} className="btn btn-icon" title="Voir details" style={{ color: '#3B82F6' }}>
                                                    <FiEye />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    {commerciaux.length === 0 && (
                                        <tr><td colSpan={9} style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Aucun commercial trouve</td></tr>
                                    )}
                                </tbody>
                            </table>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderTop: '1px solid #f3f4f6' }}>
                                    <span style={{ fontSize: 13, color: '#6b7280' }}>{total} commerciaux</span>
                                    <div style={{ display: 'flex', gap: 4 }}>
                                        <button disabled={page <= 1} onClick={() => setPage(p => p - 1)} className="btn btn-outline btn-sm"><FiChevronLeft /></button>
                                        <span style={{ padding: '6px 12px', fontSize: 13 }}>Page {page}/{totalPages}</span>
                                        <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)} className="btn btn-outline btn-sm"><FiChevronRight /></button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}

            {/* === TAB EQUIPES === */}
            {tab === 'equipes' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 18 }}>
                    {statsEquipes.map(eq => {
                        const equipe = equipes.find(e => e.id === eq.id);
                        const maxCa = Math.max(...statsEquipes.map((s: any) => n(s.total_ca)), 1);
                        const barPct = Math.round((n(eq.total_ca) / maxCa) * 100);
                        return (
                            <div key={eq.id} style={{ background: '#fff', borderRadius: 14, border: '1px solid #E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', overflow: 'hidden', transition: 'box-shadow 0.2s, transform 0.2s' }}
                                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                                {/* Colored top strip */}
                                <div style={{ height: 4, background: `linear-gradient(90deg, ${eq.couleur}, ${eq.couleur}AA)` }} />
                                <div style={{ padding: '18px 20px' }}>
                                    {/* Header */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                            <div style={{ width: 40, height: 40, borderRadius: 10, background: `${eq.couleur}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: eq.couleur, fontWeight: 800, fontSize: 16 }}>
                                                {eq.nom?.[0]}
                                            </div>
                                            <div>
                                                <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#1E293B' }}>{eq.nom}</h3>
                                                {equipe?.responsable_nom && (
                                                    <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 2 }}>
                                                        <FiUsers size={11} style={{ verticalAlign: 'middle', marginRight: 3 }} />
                                                        {equipe.responsable_nom}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: 2 }}>
                                            <button onClick={() => handleOpenAssign(eq.id)} className="btn btn-icon" title="Gerer membres"
                                                style={{ color: '#3B82F6', width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiUserPlus size={15} /></button>
                                            <button onClick={() => handleEditEquipe(equipe || eq)} className="btn btn-icon" title="Modifier"
                                                style={{ color: '#F59E0B', width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiEdit2 size={15} /></button>
                                            <button onClick={() => handleDeleteEquipe(eq.id)} className="btn btn-icon" title="Supprimer"
                                                style={{ color: '#EF4444', width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiTrash2 size={15} /></button>
                                        </div>
                                    </div>

                                    {/* KPI badges */}
                                    <div className="kpi-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: 10, marginBottom: 14 }}>
                                        <div className="kpi-card" style={{ borderLeftColor: eq.couleur }}>
                                            <div className="kpi-content">
                                                <span className="kpi-value">{n(eq.nb_membres)}</span>
                                                <span className="kpi-label">Membres</span>
                                            </div>
                                        </div>
                                        <div className="kpi-card" style={{ borderLeftColor: '#16A34A' }}>
                                            <div className="kpi-content">
                                                <span className="kpi-value">{n(eq.total_activites)}</span>
                                                <span className="kpi-label">Activites</span>
                                            </div>
                                        </div>
                                        <div className="kpi-card" style={{ borderLeftColor: '#3B82F6' }}>
                                            <div className="kpi-content">
                                                <span className="kpi-value">{fmt(eq.total_ca)} F</span>
                                                <span className="kpi-label">CA du mois</span>
                                            </div>
                                        </div>
                                        <div className="kpi-card" style={{ borderLeftColor: '#8B5CF6' }}>
                                            <div className="kpi-content">
                                                <span className="kpi-value">{n(eq.total_clients)}</span>
                                                <span className="kpi-label">Clients</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Progress bar */}
                                    <div style={{ height: 7, background: '#F1F5F9', borderRadius: 4, overflow: 'hidden' }}>
                                        <div style={{ height: '100%', width: `${barPct}%`, background: `linear-gradient(90deg, ${eq.couleur}, ${eq.couleur}AA)`, borderRadius: 4, transition: 'width 0.6s ease' }} />
                                    </div>

                                    {/* CA moyen */}
                                    {n(eq.nb_membres) > 0 && (
                                        <div style={{ marginTop: 10, padding: '8px 12px', background: '#F8FAF9', borderRadius: 8, border: '1px solid #F1F5F9', textAlign: 'center', fontSize: 12, color: '#64748B' }}>
                                            CA moyen/membre: <strong style={{ color: '#1E293B' }}>{fmt(n(eq.total_ca) / n(eq.nb_membres))} F</strong>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    {/* Bouton ajouter equipe */}
                    <div onClick={handleCreateEquipe}
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 240, cursor: 'pointer', border: '2px dashed #E2E8F0', borderRadius: 14, background: '#FAFBFC', color: '#94A3B8', transition: 'all 0.2s' }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = '#16A34A'; e.currentTarget.style.color = '#16A34A'; e.currentTarget.style.background = '#F0FDF4'; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.color = '#94A3B8'; e.currentTarget.style.background = '#FAFBFC'; }}>
                        <FiPlus size={32} />
                        <span style={{ marginTop: 8, fontWeight: 600, fontSize: 14 }}>Nouvelle equipe</span>
                    </div>
                </div>
            )}

            {/* Modal Equipe */}
            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
                        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                            <h3 style={{ margin: 0 }}>{editEquipe ? 'Modifier equipe' : 'Nouvelle equipe'}</h3>
                            <button onClick={() => setShowModal(false)} className="btn btn-icon"><FiX /></button>
                        </div>
                        <div className="form-group">
                            <label>Nom *</label>
                            <input type="text" value={eqForm.nom} onChange={e => setEqForm({ ...eqForm, nom: e.target.value })}
                                style={{ width: '100%', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 8 }} />
                        </div>
                        <div className="form-group">
                            <label>Description</label>
                            <textarea value={eqForm.description} onChange={e => setEqForm({ ...eqForm, description: e.target.value })}
                                rows={3} style={{ width: '100%', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 8, resize: 'vertical' }} />
                        </div>
                        <div className="form-row" style={{ display: 'flex', gap: 12 }}>
                            <div className="form-group" style={{ flex: 1 }}>
                                <label>Couleur</label>
                                <input type="color" value={eqForm.couleur} onChange={e => setEqForm({ ...eqForm, couleur: e.target.value })}
                                    style={{ width: '100%', height: 40, border: 'none', cursor: 'pointer' }} />
                            </div>
                            <div className="form-group" style={{ flex: 2 }}>
                                <label>Responsable</label>
                                <select value={eqForm.responsable_id} onChange={e => setEqForm({ ...eqForm, responsable_id: e.target.value })}
                                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 8 }}>
                                    <option value="">Aucun</option>
                                    {commerciaux.map(c => <option key={c.id} value={c.id}>{c.prenom} {c.nom}</option>)}
                                </select>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
                            <button onClick={() => setShowModal(false)} className="btn btn-outline">Annuler</button>
                            <button onClick={handleSaveEquipe} className="btn btn-primary">{editEquipe ? 'Modifier' : 'Creer'}</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Assign Members */}
            {showAssign && (
                <div className="modal-overlay" onClick={() => setShowAssign(false)}>
                    <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 500, maxHeight: '80vh', overflow: 'auto' }}>
                        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <h3 style={{ margin: 0 }}>Gerer les membres</h3>
                            <button onClick={() => setShowAssign(false)} className="btn btn-icon"><FiX /></button>
                        </div>
                        <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 12 }}>
                            Cochez les commerciaux a ajouter dans cette equipe ({assignMembers.length} selectionnes)
                        </p>
                        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                            {allCommerciaux.map(c => (
                                <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6' }}>
                                    <input type="checkbox" checked={assignMembers.includes(c.id)} onChange={() => toggleMember(c.id)} />
                                    <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600, color: '#16A34A' }}>
                                        {c.prenom?.[0]}{c.nom?.[0]}
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 500, fontSize: 14 }}>{c.prenom} {c.nom}</div>
                                        <div style={{ fontSize: 12, color: '#9ca3af' }}>{c.zone_nom || 'Sans zone'}{c.equipe_nom ? ` - ${c.equipe_nom}` : ''}</div>
                                    </div>
                                </label>
                            ))}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                            <button onClick={() => setShowAssign(false)} className="btn btn-outline">Annuler</button>
                            <button onClick={handleSaveMembers} className="btn btn-primary" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <FiCheck /> Sauvegarder
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Commerciaux;
